export default "__VITE_ASSET__DAMib575__"